// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"70cf25ad","82":"68a3a03f","247":"0b9fe2a3","417":"dbd5a468","453":"6413b9b0","551":"e87ce35d","627":"d2fe399b","749":"6328ffe8","867":"19fd3d9d","923":"ad08c559","938":"8d3c2ec4","950":"e18d6f68"}[chunkId] + ".chunk.js";
};